import { useEffect, useRef, useState } from 'react';
import { MaybeLayout } from '../components/layout/MaybeLayout';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Loader2, RefreshCw, Shield } from 'lucide-react';
import { toast } from 'sonner';
import { adminAuditAPI } from '../lib/api';

export default function ApiAudit({ embedded = false }) {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await adminAuditAPI.getHtml();
      setHtml(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Audit konnte nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <MaybeLayout embedded={embedded}>
      <div className="space-y-6" data-testid="api-audit-page">
        <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
              <Shield className="h-7 w-7 text-blue-600" />
              API Endpoint Audit
            </h1>
            <p className="text-muted-foreground text-sm mt-1">
              Live-Übersicht aller Frontend → Backend Endpoint-Calls inklusive Permission-Gates und Drift-Erkennung.
            </p>
          </div>
          <Button
            variant="outline"
            className="rounded-full"
            onClick={load}
            disabled={loading}
            data-testid="refresh-audit-btn"
          >
            <RefreshCw className={`mr-2 h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
            Aktualisieren
          </Button>
        </div>

        <Card>
          <CardContent className="p-0">
            {loading && !html ? (
              <div className="flex items-center justify-center py-24">
                <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
              </div>
            ) : (
              <iframe
                ref={iframeRef}
                title="API Audit Dashboard"
                srcDoc={html}
                className="w-full border-0 rounded-b-xl"
                style={{ height: 'calc(100vh - 220px)', minHeight: '600px' }}
                data-testid="api-audit-iframe"
              />
            )}
          </CardContent>
        </Card>
      </div>
    </MaybeLayout>
  );
}
